import mLogo from 'assets/images/m_logo.svg';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  return <img src={mLogo} alt="logo" style={{ width: 40, height: 24 }} />;
}
